import ACTIONS from './action-types'

export const startFNAFlow = () => {
  return {
    type: ACTIONS.START_FNA_FLOW,
  }
}

export const startQQFlow = () => {
  return {
    type: ACTIONS.START_QQ_FLOW,
  }
}
